import { createSlice } from '@reduxjs/toolkit'
import {postWorkshopList,postWorkshopCount} from "./thunks"

const initialState= { 
  list: {

    pageIndex: 0,
totalRecords: 50,
totalPages: 1,
hasPreviousPage: false,
hasNextPage: false,
elements: []
  }, 
  loading: "idle",
  loadingCount: "idle",
  error: null }

const workshopsSlice = createSlice({
  name: 'workshops',
  initialState,
  reducers: {
    clearWorkshopError:(state)=>{
      state.error= null
    },
    setWorkshopFilters:(state, action)=>{
      state.filters= action.payload
    }
  },
  extraReducers: {
    [postWorkshopList.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [postWorkshopList.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.list.elements = action.payload.elements;
    },
    [postWorkshopList.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
    },
    [postWorkshopCount.pending]: (state) => {
      state.loadingCount = "loading"; 
      state.error = null
    },
    [postWorkshopCount.fulfilled]: (state, action) => {
      state.loadingCount = "succeeded";
      state.list.pageIndex = action.payload.pageIndex;
      state.list.totalRecords = action.payload.totalRecords;
      state.list.totalPages = action.payload.totalPages;
      state.list.hasPreviousPage = action.payload.hasPreviousPage;
      state.list.hasNextPage =action.payload.hasNextPage;

    },
    [postWorkshopCount.rejected]: (state, action) => {
      state.loadingCount = "failed"; 
      state.error = action.error.message
    }
  }
})

export const {clearWorkshopError, setWorkshopFilters} = workshopsSlice.actions

export default workshopsSlice.reducer
